import { useTranslation } from "react-i18next";
import TaskList from "./TaskList";
import { useDispatch } from "../providers/DispatchProvider";

export default function SlimDispatchView(props) {
  const { tabIndex, orderTasksBy, filterTasksBy } = props;
  const { t } = useTranslation();


  const {showLoading, activeTasks, completedTasks } = useDispatch();

  return (
    tabIndex === 0 ?
      <TaskList
        orderTasksBy={orderTasksBy}
        filterTasksBy={filterTasksBy}
        tasks={activeTasks}
        showLoading={showLoading}
        emptyStateTitle={t("dispatch:activeTasks:emptyStateTitle")}
        emptyStateDescription={t("dispatch:activeTasks:emptyStateDescription")}
        emptyStateFilteredDescription={t("dispatch:activeTasks:emptyStateFilteredDescription")}
        slim
      /> :
      <TaskList
        tasks={completedTasks}
        showLoading={showLoading}
        emptyStateTitle={t("dispatch:completedTasks:emptyStateTitle")}
        emptyStateDescription={t("dispatch:completedTasks:emptyStateDescription")}
        slim
      />
  );
}